export type TableProps = {
  data?: WorkVehicleType[];
};

// ✅ NUEVO: Tabla para vehículos de obra (CONSTRUCTION)
export type WorkVehicleType = {
  plate: string; // Matrícula
  model: string; // Modelo
  category: string; // Categoría
  driver?: string; // Conductor (Opcional)
  ownership: 'INTERNAL' | 'EXTERNAL'; // Propiedad (Intern/Extern)
};

type columnIDTypes = { [key: string]: { id: string; label: string } };

// Dynamic column names with translations
export const getWorkVehiclesColumnNames = (t: any): columnIDTypes => ({
  plate: {
    id: 'plate',
    label: t('tables:headers.plate'),
  },
  model: {
    id: 'model',
    label: t('tables:headers.model'),
  },
  category: {
    id: 'category',
    label: t('tables:headers.category'),
  },
  driver: {
    id: 'driver',
    label: t('tables:headers.driver'),
  },
  ownership: {
    id: 'ownership',
    label: t('tables:headers.ownership'),
  },
});

